export default {
      id: "title-helicopters-usage",
      viewBox: "0 0 179 14",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#title-helicopters",
      toString: function () {
        return this.url;
      }
    }